'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularMaterial = require('angular-material');

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _angularMessages = require('angular-messages');

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _admin = require('../api/admin.service');

var _admin2 = _interopRequireDefault(_admin);

var _confirmOnExit = require('../components/confirm-on-exit.directive');

var _confirmOnExit2 = _interopRequireDefault(_confirmOnExit);

var _toast = require('../services/toast');

var _toast2 = _interopRequireDefault(_toast);

var _admin3 = require('./admin.routes');

var _admin4 = _interopRequireDefault(_admin3);

var _admin5 = require('./admin.controller');

var _admin6 = _interopRequireDefault(_admin5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.admin', [_angularUiRouter2.default, _angularMaterial2.default, _angularMessages2.default, _admin2.default, _confirmOnExit2.default, _toast2.default]).config(_admin4.default).controller('AdminController', _admin6.default).name;


// WEBPACK FOOTER //
// ./src/app/admin/index.js